import script from "./updateLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./updateLogs.vue?vue&type=script&setup=true&lang=js"

import "./updateLogs.vue?vue&type=style&index=0&id=186d4cde&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ros-kepler-tecowebsite(r项目开发者平台)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-186d4cde"]])

export default __exports__